import { render } from "./WorkspaceBar.vue?vue&type=template&id=4f3fd444"
import script from "./WorkspaceBar.vue?vue&type=script&lang=js"
export * from "./WorkspaceBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__